'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _tradeTypes = require('./tradeTypes');

var _tradeTypes2 = _interopRequireDefault(_tradeTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (type) {
    var typeDetails = _tradeTypes2.default.find(function (x) {
        return x.value === type;
    });
    return !!(typeDetails && typeDetails.barrier);
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/trade/typeHasBarrier.js
// module id = 30
// module chunks = 0